<script setup lang="ts">
  import { type PropType, computed } from 'vue';
  import { useTranslator } from '@othercommerce/foundation';
  import { Unit, ProductType } from '@othercommerce/domain';

  interface Product {
    type: ProductType;
    stockUnit: Unit;
    stockAvailable: string;
    stockOnOrder: true;
  }

  const props = defineProps({
    product: { type: Object as PropType<Product>, required: true },
  });

  const translator = useTranslator();

  const onOrder = computed(() => {
    return props.product.stockOnOrder;
  });

  const isFlexibleSet = computed(() => {
    return props.product.type === ProductType.FLEXIBLE;
  });

  const available = computed(() => {
    return onOrder.value || Number(props.product.stockAvailable) > 0;
  });

  const message = computed(() => {
    if (isFlexibleSet.value) {
      return translator.trans('SHOP.COMMON.LABEL.STOCK_CHECK_AVAILABILITY');
    } else if (onOrder.value) {
      return translator.trans('SHOP.COMMON.LABEL.STOCK_AVAILABLE_ON_ORDER');
    } else if (available.value) {
      return translator.trans('SHOP.COMMON.LABEL.STOCK_LEVEL_AVAILABLE');
    } else {
      return translator.trans('SHOP.COMMON.LABEL.STOCK_UNAVAILABLE');
    }
  });
</script>
<template>
  <div class="product-availability" :class="{ available }" v-html="message" />
</template>
<style scoped lang="scss">
  .product-availability {
    display: flex;
    align-items: center;
    font-size: 0.625rem;
    text-transform: uppercase;
    font-weight: var(--font-weight-semi);
    gap: 0.5rem;

    &:before {
      content: "";
      background-color: #f87171;
      border: 1px solid #ef444488;
      box-shadow: 0 0 3px 1px #f87171fa;
      border-radius: 5px;
      height: 8px;
      width: 8px;
    }

    &.available {
      &:before {
        background-color: #a3e635;
        border-color: #84cc1688;
        box-shadow: 0 0 3px 1px #a3e635fa;
      }
    }
  }
</style>
